var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivityInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 5,
    viewBox: "0 0 10 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.766999 4.53334C0.941138 4.5337 1.11013 4.4743 1.24574 4.36506L2.41088 3.43366C2.64616 3.24478 2.94293 3.14949 3.24418 3.16611C3.54544 3.18272 3.82993 3.31007 4.043 3.52368C4.53474 4.00917 5.18979 4.29391 5.88022 4.32228C6.57065 4.35065 7.24687 4.12063 7.77678 3.67712L9.70197 2.04807C9.784 1.98467 9.85232 1.90531 9.90282 1.81477C9.95332 1.72423 9.98495 1.6244 9.99579 1.52129C10.0066 1.41819 9.99647 1.31396 9.96591 1.2149C9.93536 1.11584 9.88504 1.02399 9.818 0.944916C9.75096 0.865839 9.66859 0.801169 9.57587 0.75481C9.48314 0.708452 9.38198 0.681367 9.27849 0.675191C9.17501 0.669015 9.07134 0.683876 8.97376 0.718876C8.87618 0.753877 8.7867 0.808291 8.71073 0.878834L6.78605 2.50789C6.55031 2.70446 6.24975 2.80605 5.9431 2.79281C5.63645 2.77957 5.34576 2.65244 5.12784 2.43628C4.64811 1.9552 4.00761 1.66824 3.32927 1.63049C2.65093 1.59273 1.98253 1.80683 1.45238 2.23169L0.287746 3.16718C0.163667 3.26651 0.0735 3.40192 0.0297031 3.55471C-0.0140938 3.70749 -0.00935847 3.87011 0.0432547 4.02009C0.0958678 4.17007 0.193762 4.3 0.32341 4.39195C0.453058 4.48389 0.60806 4.53329 0.766999 4.53334Z",
    fill: "#868E96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityInactive);
export default __webpack_public_path__ + "static/media/ActivityInactive.0bf68c544d28a7c2c2d8647a5700c24c.svg";
export { ForwardRef as ReactComponent };